import fetch from 'isomorphic-fetch';
import { API } from '../../config';

export const getAllCustomers = async () => {
  try {
    const response = await fetch(`${API}/customers`, {
      method: 'GET',
    });
    return await response.json();
  } catch (error) {
    return console.error(error);
  }
};

